<template>
  <div class="controls">
    <!-- Pagination, etc. -->
    <Paginate
      v-model="page"
      :page-count="pagesTotal"
      :page-range="3"
      :class="{ 'disabled': $attrs.disabled, }"
      prev-text="<"
      next-text=">"
      container-class="pagination-container"
      page-class="page-item"
      break-view-class="points"
    />

    <!-- Limite de résultats -->
    <b-form-group
      label="Résultats par page"
      label-for="limite"
    >
      <b-form-select
        id="limite"
        v-model="limite"
        :options="limiteOptions"
        :disabled="$attrs.disabled"
      />
    </b-form-group>
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";

export default {
  name: "PaginationControls",
  components: {
    Paginate,
  },
  props: {
    pageActuelle: {
      type: Number,
      required: true,
    },
    limiteActuelle: {
      type: Number,
      required: true,
    },
    pagesTotal: {
      type: Number,
      required: true,
    },
    limiteOptions: {
      type: Array,
      default: () => [25, 50, 100],
    },
  },
  emits: ["update"],
  computed: {
    page: {
      get() {
        return this.pageActuelle;
      },
      set(value) {
        this.$emit("update", {
          page: value,
          limite: this.limite,
        });
      },
    },
    limite: {
      get() {
        return this.limiteActuelle;
      },
      set(value) {
        this.$emit("update", {
          page: 1,
          limite: value,
        });
      },
    },
  },
};
</script>
